export function cast<T>(arg: any): T {
	return arg as T;
}